import {SmartPlugin} from '../smart'

export class MediaQueryManager extends SmartPlugin {
    constructor(props){
        super('mediaquery-manager', props);
        this.$byQuery = {};
        this.$byName = {};
        this.$stylesheet = null;
    }
    
    getByName(name) {
        var query = this.$byName[name];
        return query ? this.$byQuery[query] : null;
    }
    
    
    getByQuery (query) {
        return this.$byQuery[query];
    }
    ensureQuery(query, names) {
        var mq = this.getByQuery(query);
        if (mq) {
            this.assignNames(names, query);
        } else {
            mq = this.createQuery(query, names);
        }
    
        return mq;
    }
    createQuery(query, names) {
        var mq = { query, stylesheet: null, chunks: [] };
        this.$byQuery[query] = mq;
        this.assignNames(names, query);
        return mq;
    }
    assignName(aliasName, query) {
        this.$byName[aliasName] = query;
    }
    assignNames(aliasNames, query) {
        if (!aliasNames || aliasNames.length === 0)
            return;
        aliasNames.forEach(name => this.assignName(name, query));
    }
    rebuild() {
        var jss = this.$options.smart.$plugins['smart-jss'].$jss;
        var byQuery = this.$byQuery;
    
        var jssRoot = {};
        Object.keys(byQuery).forEach(function (key) {
            var mq = byQuery[key];
            var jssData;
            if(mq.chunks.length > 0){
                jssData = mq.chunks.reduce((data, chunk) => {
                    return { ...data, ...chunk };
                },{});
    
                jssRoot[`@media ${key}`] = jssData;
            }
        });
        if (this.$stylesheet)
            this.$stylesheet.detach();
        if(Object.keys(jssRoot).length == 0){
            this.$stylesheet = null;
            return;
        }
            
        this.$stylesheet = jss.createStyleSheet(jssRoot);
        this.$stylesheet.attach();
    }
    clear() {
        if (this.$stylesheet)
            this.$stylesheet.detach();
        this.$stylesheet = null;
        this.$byQuery = {}
        this.$byName = {}
    }
}